import React from 'react';
var defaultOverlayContext = {
  overlayProvider: false,
  addPortal: function addPortal() {},
  removePortal: function removePortal() {},
  portalRefs: {}
};
export var OverlayContext = /*#__PURE__*/React.createContext(defaultOverlayContext);